import React from 'react';
import * as R from 'ramda';
import {useTranslation} from 'react-i18next';

import InsurancePlanDetail from '@/b2c/PlanDetail/Detail/InsurancePlanDetail/index';
import FundPlatformDetail from '@/b2c/PlanDetail/Detail/FundPlatformDetail/index';
import InvestmentLinkDetail from '@/b2c/PlanDetail/Detail/InvestmentLinkDetail/index';

const Detail = ({plan}) => {
  const {t: tr} = useTranslation('planDetail');
  const CategoryMappedDetail = R.compose(
    R.flip(R.prop)({
      MPF: FundPlatformDetail,
      FD: FundPlatformDetail,
      PB: FundPlatformDetail, // any non 'Policy' product category shall go into FundPlatform
      IN: InsurancePlanDetail,
      IL: InvestmentLinkDetail,
      TU: InvestmentLinkDetail,
    }),
    R.prop('productCategory')
  )(plan);

  return (
    <article style={{borderLeft: '0px'}}>
      <h4>{tr('details')}</h4>
      <CategoryMappedDetail plan={plan} />
    </article>
  );
};

export default Detail;
